module.exports = __webpack_public_path__ + "img/Estrellita.549c4d24.svg";